<div class="card">
    <h5 class="card-header">
        Transfer Property
    </h5>
    <div class="card-body">
        <h5 class="card-title">
            
        </h5>
        <h5 class="card-title">
            Transferir propiedad del contrato
        </h5>
        <p class="card-text">
            Transfiere la propiedad del contrato a una nueva cuenta ("newOwner").
            Solo puede ser llamado por el propietario actual.
        </p>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="form-floating mb-3">
                <input type="text" formControlName="address" class="form-control" placeholder="Address">
                <label for="floatingInput">
                    Wallet Address
                </label>
              </div>

            <div class="d-grid gap-2 col-6 mx-auto">
                <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
                    Guardar
                </button>
            </div>

        </form>
    </div>
</div>